import { render, staticRenderFns } from "./pageNav.vue?vue&type=template&id=24d9a476&scoped=true&"
import script from "./pageNav.vue?vue&type=script&lang=js&"
export * from "./pageNav.vue?vue&type=script&lang=js&"
import style0 from "./pageNav.vue?vue&type=style&index=0&id=24d9a476&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9a476",
  null
  
)

export default component.exports